const SERVICE_WORKER_PATH = '/sw.js';
const HOSTED_DESKTOP_HOST = 'app.ourlanterns.com';

function isSecureHttpContext() {
  if (!window.isSecureContext) {
    return false;
  }

  if (window.location.protocol !== 'http:' && window.location.protocol !== 'https:') {
    return false;
  }

  return true;
}

function shouldRegisterServiceWorker() {
  return import.meta.env.PROD || window.location.hostname === HOSTED_DESKTOP_HOST;
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  if (!isSecureHttpContext() || !shouldRegisterServiceWorker()) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register(SERVICE_WORKER_PATH, {
      scope: '/',
    });
    await registration.update();
  } catch (error) {
    if (import.meta.env.DEV) {
      console.debug('[offline-cache] service worker registration failed:', error);
    }
  }
}
